// LA LISTA DE LA PANTALLA DEL RELOJ (11-10-2026).
//
// La lista salía solo del último parte guardado, así que a quien se le ponía el reloj
// después (un alta de hoy) no se le encontraba hasta el parte de mañana: el contador decía
// «94 con reloj», la lista «Todos (93)» y buscando su nombre «No hay clientes en esta lista».
// El servidor manda ahora aparte a los que tienen reloj y no están en el parte
// (`desde_el_parte`, con la misma fila que hace el parte). Aquí se juntan las dos listas y
// se cuenta sobre lo que se enseña, para que los números y la lista digan lo mismo.
//
// Lógica pura: sin React y sin red.

// Las filas del parte y, detrás, las de después, marcadas para que la pantalla lo diga.
export const filasDelReloj = (parte, desdeElParte) => {
    const delParte = parte?.filas || [];
    const ya = new Set(delParte.map((f) => f.client_id));
    const nuevas = (desdeElParte || [])
        .filter((f) => f && !ya.has(f.client_id))
        .map((f) => ({ ...f, desde_el_parte: true }));
    return [...delParte, ...nuevas];
};

// Cuántas hay de cada resultado, y `todos`.
export const cuentaDelReloj = (filas) => (filas || []).reduce(
    (c, f) => ({ ...c, [f.resultado]: (c[f.resultado] || 0) + 1 }), { todos: (filas || []).length });

// Las que se enseñan con ese filtro y esa búsqueda, por nombre.
export const filtrarFilas = (filas, filtro, buscar) => {
    const q = (buscar || '').trim().toLowerCase();
    return (filas || [])
        .filter((f) => filtro === 'todos' || f.resultado === filtro)
        .filter((f) => !q || `${f.nombre} ${f.email} ${f.plan}`.toLowerCase().includes(q))
        .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || ''));
};

// CON ACTIVECAMPAIGN APAGADO NO HAY CON QUÉ COMPARAR (13-10, hoja de los probadores, M5).
//
// El parte compara, cliente por cliente, la semana del reloj con la de ActiveCampaign, y
// cada fila llega con ese resultado (`coincide`, `difiere`, `sin_ac`), la semana de AC y un
// motivo escrito en esos términos ("AC dice semana 3"). Donde AC está apagado (lo dice el
// servidor: `modo.ac_con_clave`, de `core/semana_ac.configurado`) todas salían "Sin AC" y
// la pantalla seguía hablando de una comparación que allí no existe.
//
// Apagado, la fila dice lo único que hay que saber: si el reloj le cuenta una semana o no.
// Encendido, todo sigue como estaba (se devuelven las mismas filas, sin tocar).
export const filasSegunAC = (filas, conAC) => (conAC ? (filas || []) : (filas || []).map((f) => {
    const { ac, motivo, ...sinAC } = f;
    const resultado = f.resultado === 'sin_semanas' ? 'sin_semanas'
        : (f.app === null || f.app === undefined) ? 'sin_semana' : 'con_semana';
    return { ...sinAC, resultado };
}));

// Los filtros de la lista, con su rótulo, y el que sale puesto al entrar.
const FILTROS_CON_AC = [['difiere', 'Difieren'], ['sin_ac', 'Sin AC'], ['coincide', 'Coinciden'], ['todos', 'Todos']];
const FILTROS_SIN_AC = [['todos', 'Todos'], ['con_semana', 'Con semana'], ['sin_semana', 'Sin semana'], ['sin_semanas', 'Por meses']];
export const filtrosDelReloj = (conAC) => (conAC ? FILTROS_CON_AC : FILTROS_SIN_AC);
export const filtroDeEntrada = (conAC) => (conAC ? 'difiere' : 'todos');
